<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-role-dialog"
  >
    <div class="form-content">
      <role-form
        ref="outform"
        @submit="submit"
      ></role-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import roleForm from "@/components/sys/roleList/roleForm";
import {addRole} from "@/api/sys/roleList";

export default {
  name: "addRoleDialog",
  components: {
    roleForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form,menuIdList) {
      let params = {
        'roleName': form.roleName,
        'remark': form.remark,
        'menuIdList': menuIdList
      }
      addRole(params).then((data) => {

        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-role-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
